import * as React from 'react';
import { IconProps } from '../types';

const IcAlert = (props: IconProps) => (
  <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_15045_13662)'>
      <path
        d='M23.4657 20.055L13.7578 3.24099C13.1068 2.11364 11.4803 2.11364 10.8293 3.24099L1.1214 20.055C0.472862 21.1823 1.28606 22.5909 2.58568 22.5909H22.0014C23.301 22.5909 24.1142 21.1823 23.4657 20.055ZM11.3765 8.26467H13.2106C13.5932 8.26467 13.8946 8.59146 13.8617 8.97147L13.4513 13.8659C13.4234 14.2054 13.1397 14.4663 12.8002 14.4663H11.7869C11.4474 14.4663 11.1637 14.2054 11.1358 13.8659L10.7254 8.97147C10.6925 8.59146 10.9939 8.26467 11.3765 8.26467ZM12.2936 19.8548C11.4221 19.8548 10.7153 19.148 10.7153 18.2765C10.7153 17.4051 11.4221 16.6982 12.2936 16.6982C13.165 16.6982 13.8718 17.4051 13.8718 18.2765C13.8718 19.148 13.165 19.8548 12.2936 19.8548Z'
        fill={props?.fill ?? '#FF5403'}
      />
    </g>
    <defs>
      <clipPath id='clip0_15045_13662'>
        <rect width='24' height='24' fill='white' transform='translate(0.293457 0.493164)' />
      </clipPath>
    </defs>
  </svg>
);

export default IcAlert;
